import React from 'react';

const ProductCardWithDetailsMobilePlaceholder = () => {
  return (
    <div className="skeleton w-full p-3 lg:hidden ">
      <div className="flex gap-3">
        <a className="w-[66px]">
          <div className="aspect-[3/4] w-full min-w-[40px] rounded bg-gray-100 object-cover transition duration-500 group-hover:scale-105 hover:cursor-pointer"></div>
        </a>
        <div className="flex flex-col">
          <div className="mb-0.5 flex justify-between">
            <div className="min-w-[40px] bg-gray-100">&nbsp;</div>
            <div className="-m-2  p-2"></div>
          </div>
          <h5 className="mb-0.5 min-w-[40px] bg-gray-100">&nbsp;</h5>
          <div className="mb-0.5 inline-flex min-w-[40px] bg-gray-100 text-md text-gray-500">
            &nbsp;
          </div>
          <div className="min-w-[40px] bg-gray-100 text-md text-gray-500">
            &nbsp;
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="min-w-[40px] bg-gray-100 text-md">
          &nbsp;
          <span className="min-w-[40px] bg-gray-100 text-sm text-gray-500">
            &nbsp;
          </span>
        </div>
        <div className="min-w-[40px] bg-gray-100">&nbsp;</div>
      </div>
      <div className="flex w-full md-down:grid md-down:grid-cols-[1fr_1fr_1fr_1fr] md-down:gap-3">
        <div className="min-w-[40px] bg-gray-100">&nbsp;</div>
        <div className="min-w-[40px] bg-gray-100">&nbsp;</div>
        <div className="min-w-[40px] bg-gray-100">&nbsp;</div>
        <div className="min-w-[40px] bg-gray-100">&nbsp;</div>
      </div>
      <div>
        <button className="flex items-center gap-0.5 self-start py-2">
          <span className="min-w-[40px] bg-gray-100 text-md">&nbsp;</span>
        </button>
      </div>
    </div>
  );
};

export default ProductCardWithDetailsMobilePlaceholder;
